<birdz-panel>
  <mat-tab-group
    [(selectedIndex)]="selectedTab"
    animationDuration="200ms"
    [mat-stretch-tabs]="false"
    class="birdz-filter-tab-group"
  >
    <mat-tab label="{{ 'FILTERS' | transloco }}">
      <form class="filters" [formGroup]="form">
        <mat-accordion [multi]="true" class="bdz-filter-accordion">
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>{{ 'QUERIES' | transloco }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="filter-fields">
              <mat-form-field>
                <mat-label>{{ 'QUERY_DATABASE' | transloco }}</mat-label>
                <mat-select formControlName="database_id" panelClass="birdz-wide-select">
                  <birdz-select-search-bar
                    [options]="databases"
                    [searchFunction]="searchDbFn"
                    [showAll]="false"
                    [showNone]="false"
                    #dbSearch
                  >
                  </birdz-select-search-bar>
                  <mat-option [value]="null">—</mat-option>
                  @for (db of databases | filter: dbSearch.filter; track db.id) {
                    <mat-option [value]="db.id">{{ db.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field>
                <mat-label>{{ 'QUERY_CREATOR' | transloco }}</mat-label>
                <mat-select formControlName="creator_email" panelClass="birdz-wide-select">
                  <birdz-select-search-bar
                    [options]="creators"
                    [searchFunction]="searchStringFn"
                    [showAll]="false"
                    [showNone]="false"
                    #creatorSearch
                  >
                  </birdz-select-search-bar>
                  <mat-option [value]="null">—</mat-option>
                  @for (creator of creators | filter: creatorSearch.filter; track creator) {
                    <mat-option [value]="creator">{{ creator }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field>
                <mat-label>{{ 'QUERY_TAGS' | transloco }}</mat-label>
                <mat-select formControlName="tags" multiple panelClass="birdz-wide-select">
                  <birdz-select-search-bar [options]="tags" [searchFunction]="searchStringFn" #tagSearch>
                  </birdz-select-search-bar>
                  @for (tag of tags | filter: tagSearch.filter; track tag) {
                    <mat-option [value]="tag">{{ tag }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field>
                <mat-label>{{ 'QUERY_TABLE_NAME' | transloco }}</mat-label>
                <input matInput formControlName="table_name" />
              </mat-form-field>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>{{ 'FILTER_VISIBILITY' | transloco }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="filter-fields">
              <mat-radio-group formControlName="only_private" class="filter-radio-group">
                <mat-radio-button [value]="false">{{ 'FILTER_ALL_QUERIES' | transloco }}</mat-radio-button>
                <mat-radio-button [value]="true">{{ 'FILTER_PRIVATE_QUERIES' | transloco }}</mat-radio-button>
              </mat-radio-group>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>{{ 'FILTER_QUERY_STATUS' | transloco }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="filter-fields">
              <mat-checkbox formControlName="show_active">
                {{ 'FILTER_SHOW_ACTIVE' | transloco }}
              </mat-checkbox>
              <mat-checkbox formControlName="show_deleted">
                {{ 'FILTER_SHOW_DELETED' | transloco }}
              </mat-checkbox>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </form>
    </mat-tab>
  </mat-tab-group>

  <div footer class="footer">
    <form [formGroup]="form">
      <button matButton="outlined" (click)="reset()">
        {{ 'RESET_FILTERS' | transloco }}
      </button>
      <button matButton="filled" [disabled]="isApplied" (click)="submit()">
        {{ 'APPLY' | transloco }}
      </button>
    </form>
  </div>
</birdz-panel>
